import {
  createContext,
  useContext,
  useMemo,
  useRef,
  type MutableRefObject,
  type ReactNode,
} from 'react';

/**
 * Shared ref for the current in-flight attempt id. `useAttempt` updates it
 * when an attempt starts/ends; `useSoluuDevice` reads it inside the BLE debug
 * callback so each event can be tagged with the attempt it belongs to. A ref
 * rather than React state keeps the BLE callback closure stable — no need to
 * re-subscribe whenever the attempt id changes.
 */
type AttemptIdRef = MutableRefObject<string | null>;

const AttemptIdContext = createContext<AttemptIdRef | null>(null);

export function AttemptIdProvider({ children }: { children: ReactNode }) {
  const ref = useRef<string | null>(null);
  const value = useMemo(() => ref, []);
  return <AttemptIdContext.Provider value={value}>{children}</AttemptIdContext.Provider>;
}

export function useAttemptIdRef(): AttemptIdRef {
  const ctx = useContext(AttemptIdContext);
  if (!ctx)
    throw new Error('useAttemptIdRef must be used inside <AttemptIdProvider>');
  return ctx;
}
